<template>
    <div class="book-now-main">
        <div class="book-now-content">
            <div class="book-now-center">
                <el-form :model="userInfo" :rules="rules" ref="form" label-width="7.375rem">
                    <div class="from">
                        <div class="left-from">
                            <div class="title">Book Now</div>
                            <div class="from-content">
                                <div class="from-input" @click="$refs.newNameInput.focus()">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>First Name</div>
                                        <el-form-item prop="newName">
                                            <div class="input">
                                                <el-input ref="newNameInput" v-model="userInfo.newName" :maxlength="100"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                                </div>
                                <div class="from-input" @click="$refs.oldNameInput.focus()">
                                    <div class="left">
                                        <div class="left-title">Last Name</div>
                                        <el-form-item prop="oldName">
                                            <div class="input">
                                                <el-input ref="oldNameInput" v-model="userInfo.oldName" :maxlength="100"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                                </div>
                                <div class="from-input" @click="$refs.emailInput.focus()">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>Email Address</div>
                                        <el-form-item prop="email">
                                            <div class="input">
                                                <el-input ref="emailInput" v-model="userInfo.email"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                                </div>
                                <div class="from-input" @click="$refs.phoneInput.focus()">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>Phone</div>
                                        <el-form-item prop="phone">
                                            <div class="input">
                                                <el-input 
                                                    v-model="userInfo.phone" 
                                                    ref="phoneInput"
                                                    @input="validatePositiveInteger(userInfo.phone,3)" 
                                                    :maxlength="20"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <!-- <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line1.png" alt=""></div> -->
                                </div>
                                <!-- <div class="from-input">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>Arrival Date</div>
                                        <el-form-item prop="arrivalDate">
                                            <div class="input">
                                                <div class="block">
                                                    <el-date-picker 
                                                        v-model="userInfo.arrivalDate" 
                                                        type="date" 
                                                        :picker-options="pickerOptions" 
                                                        @input="startTimeChange"
                                                    ></el-date-picker>
                                                </div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/from/time.png" alt=""></div>
                                </div> -->
                                <!-- <div class="from-input end-time-input">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>Departure Date</div>
                                        <el-form-item prop="departureDate">
                                            <div class="input">
                                                <div class="block">
                                                    <el-date-picker 
                                                        v-model="userInfo.departureDate" 
                                                        type="date" 
                                                        :picker-options="departurePickerOptions" 
                                                        :disabled="isInputMask ? true : false"
                                                    ></el-date-picker>
                                                </div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/from/time.png" alt=""></div>
                                     <div class="mask" v-show="isInputMask" @click="endTimeClickNoticeEvent"></div>
                                </div> -->
                                <!-- <div class="from-input">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>Adults</div>
                                        <el-form-item prop="adults">
                                            <div class="input">
                                                <el-input 
                                                :maxlength="3" 
                                                v-model="userInfo.adults" 
                                                @input="validatePositiveInteger(userInfo.adults,1)"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line2.png" alt=""></div>
                                </div>
                                <div class="from-input">
                                    <div class="left">
                                        <div class="left-title"><span style="color: red;">*</span>Children (≤13)</div>
                                        <el-form-item prop="child">
                                            <div class="input">
                                                <el-input 
                                                :maxlength="3" 
                                                v-model="userInfo.child"
                                                 @input="validatePositiveInteger(userInfo.child,2)"></el-input>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div class="img"><img loading="lazy"  src="../../../static/img/bookNow/line2.png" alt=""></div>
                                </div> -->
                                 <div class="from-input select-input">
                                    <div class="left" @click="isDaysShow = !isDaysShow">
                                        <div class="left-title"><span style="color: red;">*</span>Days</div>
                                        <el-form-item prop="days">
                                            <div class="input">
                                                <div class="select-text">{{userInfo.days}}</div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div 
                                    :style="{ transform: isDaysShow ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.8s ease-in-out',}"
                                    @click="isDaysShow = !isDaysShow" 
                                    class="img" 
                                    id="rotate-img"><img loading="lazy"  src="../../../static/img/bookNow/icon.png" alt=""></div>
                                    <selectComponent :id="1" :options="dayOptions" @fatherSelectItem="childSelectItem" v-if="isDaysShow"/>
                                </div>
                                <div class="from-input select-input">
                                    <div class="left" @click="isGradeShow = !isGradeShow">
                                        <div class="left-title"><span style="color: red;">*</span>Classification</div>
                                        <el-form-item prop="grade">
                                            <div class="input">
                                                <div class="select-text">{{userInfo.grade}}</div>
                                            </div>
                                        </el-form-item>
                                    </div>
                                    <div 
                                    :style="{ transform: isGradeShow ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.8s ease-in-out' }"
                                     class="img" 
                                     id="rotate-img"
                                      @click="isGradeShow = !isGradeShow"><img loading="lazy"  src="../../../static/img/bookNow/icon.png" alt=""></div>
                                    <selectComponent :id="2" :options="options" @fatherSelectItem="childSelectItem" v-if="isGradeShow"/>
                                </div>
                                <div class="choose">
                                    <div class="text">
                                        Would you like to be contacted by a travel consultant?<span style="color: red;">*</span>
                                    </div>
                                    <div class="radio">
                                        <div class="radio-item" v-for="item in radioList" :key="item.id">
                                            <div class="img" :class="{'notActive':userInfo.radio != item.id}" @click="radioClickEvent(item.id)"><img loading="lazy"  v-show="userInfo.radio == item.id" src="../../../static/img/bookNow/from/Checklist.png" alt=""></div>
                                            <div class="info">{{item.info}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                                <div class="submit" v-show="innerWidth > 799">
                                    <div class="btn" @click="submitForm">Submit</div>
                                </div>
                        </div>
                        <div class="right-from">
                            <img loading="lazy"  src="../../../static/img/product/fromImg.png" alt="">
                            <div class="textarea">
                                <div class="textarea-title">Message the host</div>
                                <el-form-item prop="message">
                                    <el-input
                                        maxlength="800"
                                        show-word-limit
                                        type="textarea"
                                        :rows="2"
                                        placeholder="Tell us more about your trip, such as your desired destination, budget per person per day, etc…"
                                        v-model="userInfo.message">
                                    </el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
                <div class="submit" v-show="innerWidth <= 799">
                    <div class="btn" @click="submitForm">Submit</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { startTimeChangeWay,startTimeRulesEvent,endTimeRulesEvent} from '../../../js/fromRules/fromRulesWay.js';
import rulesDetials from '/js/fromRules/rulesDetials.js';
import days from '/js/newProductDetils/days.js';
import selectComponent from './selectComponent/selectComponent.vue';
export default {
    components:{
        selectComponent
    },
    props:{
        viewportWidth:String
    },
    data() {
        return {
            userInfo: {
                newName: '',
                oldName: '',
                email: '',
                phone: '',
                // arrivalDate: '',
                // departureDate: '',
                // adults: '',
                // child: '',
                message: '',
                days:'',
                grade:'',
                radio:'1'
            },
           rules:rulesDetials.rules,
            // pickerOptions: {
            //     disabledDate(time) {
            //         return startTimeRulesEvent(time)
            //     }
            // },
            // isInputMask:true,
            options: [{
            value: 'Advanced',
            label: 'Advanced'
            }, {
            value: 'Deluxe',
            label: 'Deluxe'
            }, {
            value: 'Luxury',
            label: 'Luxury'
            }],
            routerId:0,
            dayOptions:[{
                value: '1',
                lable: '1'
                }, {
                value: '2',
                label: '2'
                }, {
                value: '3',
                label: '3'
                }],
            radioList:[
                {
                    id:1,
                    info:'Yes'
                },
                {
                    id:2,
                    info:'No'
                }
            ],
            isGradeShow:false,
            isDaysShow:false,
            innerWidth:0
        };
    },
    mounted(){
        this.routerId = this.$route.query.id
        days.days.map(item=>{
            if(item.id == this.routerId){
                this.dayOptions = item.timeList
            }
        })
        console.log(this.dayOptions)
    },
    watch:{
        viewportWidth:{
            handler(newVal){
                this.innerWidth = newVal
            },
            immediate:true,
            deep:true
        }
    },
    // 结束时间限制
    // computed: {
    //     departurePickerOptions() {
    //         return {
    //             disabledDate: (time) => {
    //                 return endTimeRulesEvent(this.userInfo.arrivalDate,time)

    //             }
    //         };
    //     }
    // },
    methods: {
        handleCommand(val){
            this.userInfo.grade = val
        },
         // 验证人数
        validatePositiveInteger(value,id) {
            if (/^[1-9]\d*$/.test(value)) {
                // 如果是正整数
                if (id === 1) {
                    this.userInfo.adults = value;
                } 
                // else if (id === 2) {
                //     this.userInfo.child = value;
                // } else if (id === 3) {
                //     this.userInfo.phone = value;
                // }
            } else {
                // 如果不是正整数，清空相应的字段
                if (id === 1) {
                    this.userInfo.adults = '';
                } 
                // else if (id === 2) {
                //     this.userInfo.child = '';
                // } else if (id === 3) {
                //     this.userInfo.phone = '';
                // }
            }
        },
        radioClickEvent(id){
            this.userInfo.radio = id
        },
        // // 判断是否输入开始时间
        // startTimeChange() {
        //     this.isInputMask = startTimeChangeWay(this.userInfo.arrivalDate)
        // },
        // // 先选结束时间进行提示
        // endTimeClickNoticeEvent(){
        //     this.$message({
        //         message: 'Please select the arrival date',
        //         type: 'warning'
        //     });
        // },
        childSelectItem(val,id){
            if(id == 1){
                this.userInfo.days = val.label
                this.isDaysShow = false
            }else{
                this.userInfo.grade = val.label
                this.isGradeShow = false
            }
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if(this.userInfo.phone.length < 3){
                        this.$message({
                            message: 'Please enter a valid phone number',
                            type: 'warning'
                        });
                        return
                    }else{
                        this.$axios.post('/submit', this.userInfo)
                        .then(response => {
                            this.$message({
                                message:response.message,
                                type: 'success'
                            });
                        })
                        .catch(error => {
                            this.$message.error(error.message) // 处理错误
                        });
                    }
                    console.log(this.userInfo)
                } else {
                    this.$message({
                        message: 'Please fill in all required fields and ensure that the input is correct',
                        type: 'warning'
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
@import '/style/pc/common/radio.scss';
@import '/style/phone/newProductDetils/fromComponent/fromComponent.scss';
::v-deep .el-select-dropdown__item{
    font-family: Inter !important;
}
::v-deep .el-select__caret{
    font-size: 1.5rem !important;
}
::v-deep .el-input__icon{
    line-height: normal;
}
::v-deep .el-input__inner {
    width: 16rem;
    border: none;
    color: #09080D;
    font-family: Inter;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    height: 2.2rem;
    line-height: 2.2rem;
    padding: 0 !important;
}

::v-deep .el-textarea__inner {
    height: 10.7rem;
}

::v-deep .el-input__prefix {
    display: none;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

::v-deep .el-form-item__content {
    margin-left: 0 !important;
    line-height: normal !important; /* 使用默认行高 */
}

::v-deep .el-form-item__error {
    font-family: Inter;
    padding-top: 0.35rem !important;
    font-size: 0.75rem !important;
}

::v-deep .el-form-item {
    margin-bottom: 0 !important;
}

::v-deep .el-textarea__inner {
    color: #09080D;
    font-size: 0.875rem;
    font-weight: 500;
    font-family: Inter;
    font-weight: 300;
    line-height: 120%; /* 16.8px */
}
::v-deep .el-input__suffix{
    display: none;
}

.book-now-main {
    width: 100%; 
    padding: 5.625rem 0;
    display: flex;
    justify-content: center;

    .book-now-content {
        width: 75rem;
        display: flex;
        justify-content: space-between;

        .book-now-center {
            width: 100%;
        }
    }
    .title {
        color: #242527;
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 1.5rem;
        font-family: Butler;
    }
    .from {
        display: flex;
        justify-content: space-between;

        .left-from {
            .from-content {
                width: 42.5rem;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
            }
        }
        ::v-deep .choose{
            margin-bottom: 1.875rem;
        }
        .from-input {
            width: 18.375rem;
            height: 2.85rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 0.125rem;
            border: 0.0625rem solid #E5E5E7;
            padding: 0.45rem 1rem 0.45rem 1rem;
            margin-bottom: 1rem;
            .left-title{
                color: #898991;
                font-family: Inter;
                font-size: 0.875rem;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-transform: capitalize;
            }
            .select-text{
                width: 16rem;
                height: 2.2rem;
                display: flex;
                align-items: center;
            }
        }
        .select-input{
            position: relative;
            cursor: pointer;
        }
        .from-input:nth-child(5),.from-input:nth-child(6){
            margin-bottom: 1.875rem;
        }
        .end-time-input{
            position: relative;
        }
        .mask{
            position: absolute;
            width:18.625rem;
            left: 0;
            top: 0;
            height: 100%;
            z-index: 1;
        }
        .left-title {
            color: #898991;
            font-size: 0.75rem;
            font-weight: 400;
            line-height: 1.25rem;
        }

        img {
            width: 1.5rem;
            height: 1.5rem;
        }
        .rotate{
            transition: transform 0.5s ease; /* 为旋转添加过渡效果 */
            transform: rotate(180deg); /* 鼠标悬停时旋转180度 */
        }
        .right-from {
            width: 30rem;
            background: #FCFCFD;
            box-shadow: 0px 2.5rem 2rem -1.5rem rgba(15, 15, 15, 0.12);

            img {
                width: 30rem;
                height: 11.5rem;
                background: #F2F4F6;
                border-radius: 0.125rem;
            }
        }
        .textarea {
            .textarea-title {
                color: #09080D;
                font-size: 1.125rem;
                font-weight: 500;
                margin: 1rem 0 0.75rem 0;
                font-family: Inter;
            }
        }
    }
    .submit {
        // margin-top: 0.875rem;
        width: 10.25rem;
        height: 3.25rem;
        .btn {
            display: flex;
            width: 10.25rem;
            height: 3.25rem;
            padding: 0 1.25rem;
            justify-content: center;
            align-items: center;
            gap: 0.625rem;
            color: #FFF;
            font-family: Inter;
            font-size: 1rem;
            font-weight: 600;
            text-transform: capitalize;
            border-radius: 0.125rem;
            background: #061A31;
        }
        .btn:hover{
            background: #061A41;
        }
    }
}


</style>
